"use strict";

exports.__esModule = true;
exports.default = getImageSize;

/* istanbul ignore file */

/**
 * Retourne les informations sur la taille de l’image.
 * @param {object} param0
 * @param {File} param0.file
 */
function getImageSize({
  file
}) {
  return new Promise(function (resolve, reject) {
    const $img = new Image();
    $img.addEventListener("load", function () {
      resolve({
        width: $img.width,
        height: $img.height
      });
      URL.revokeObjectURL($img.src);
    }, {
      once: true
    });
    $img.addEventListener("error", function () {
      reject(null);
    }, {
      once: true
    });
    $img.src = URL.createObjectURL(file);
  });
}